import './App.scss';
import RoutesList from './Routes';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import { ThemeProvider } from './context';


function App() 
{
  return (
    <>
      <ThemeProvider>
        <Header/>
        <RoutesList />
        <Footer />
      </ThemeProvider>
    </>
  );
}

export default App;
